export default {
  dynamics: '{{change}} vs poprzedni tydzień',
};
